export default __webpack_public_path__ + "static/kemet-logo-bffcd448a67a4d5503c7e9320c89554a.jpeg";